import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import moment from 'moment';
import { useMemo } from 'react';
import { DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS } from 'views/root/views/home/views/dashboard/doraV2/dashboard.doraV2.freeTier.consts';

export const usePeriodPickerInitialValue = (
  shouldLimitPeriodPicker,
  uiState,
  currentIteration
) => {
  return useMemo(() => {
    if (shouldLimitPeriodPicker) {
      return {
        periodKey: PERIODS.PAST_90_DAYS.periodKey,
        before: moment().format(SEARCH_DATE_FORMAT),
        after: moment()
          .subtract(DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS, 'days')
          .format(SEARCH_DATE_FORMAT)
      };
    }

    const {
      dates: { from, to },
      selectedPeriodKey = PERIODS.ITERATIONS.periodKey
    } = uiState;

    return {
      periodKey: selectedPeriodKey,
      after: from,
      before: to,
      ...(selectedPeriodKey === PERIODS.ITERATIONS.periodKey && {
        selectedName: currentIteration?.name
      })
    };
  }, [shouldLimitPeriodPicker, uiState, currentIteration]);
};
